<style lang="scss" scoped>
.gif-message-element__image {
  max-width: 250px;

  img {
    max-width: 100%;
  }

  .no-image {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 250px;
    height: 250px;
  }
}

.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div class="rounded bg-secondary gif-message-element__image">
      <img v-if="value" :src="value" />
      <div class="no-image" v-else>
        Kein GIF ausgewählt
      </div>
    </div>
    <div @click="$modal.show(modalName)" class="btn btn-secondary">
      GIF auswählen
    </div>
    <div
      v-if="hasErrors"
      v-for="(error, index) in attributeErrors"
      :key="index"
      class="invalid-feedback"
    >
      <div v-for="e in error" :key="e">
        {{ e }}
      </div>
    </div>
    <modal
      width="80%"
      height="auto"
      :pivot-y="0.1"
      :adaptive="true"
      resizable
      draggable
      scrollable
      :name="modalName"
    >
      <tenor-select :name="modalName" @send-gif="emitGif"></tenor-select>
    </modal>
  </div>
</template>

<script lang="babel">
import TenorSelect from '@/components/TenorSelect.vue';

export default {
  components: {
    TenorSelect
  },
  props: {
    value: {
      required: true,
    },
    attributeErrors: {
      type: Array
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      modalName: 'gif-' + this.index
    };
  },
  computed: {
    hasErrors() {
      return this.attributeErrors !== null && this.attributeErrors.length !== 0;
    }
  },
  methods: {
    emitGif(url) {
      this.$emit('input', url);
    }
  }
}
</script>
